import axios from 'axios';

const API = 'https://sonapi.nantech.az/api/Categories';

export const getAllCategories = async () => {
  const response = await axios.get(`${API}`,{
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
        }
      });
    return response.data;
};

export const getCategoryById = async (id) => {
    const response = await axios.get(`${API}/${id}`,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    return response.data;
};

export const addCategory = async (category) => {
    const response = await axios.post(API, category,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    return response.data;
};



export const deleteCategory = async (id) => {
  try {
    const response = await axios.delete(`${API}/${id}`,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    return response.data;  
  } catch (error) {
    throw new Error("An error occurred while deleting the category.");
  }
};
export const updateCategory = async (id, category) => {
    try {
    const response = await axios.put(`${API}/${id}`, category,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      }
    }); 
      return response.data; 
    } catch (error) {
      console.error("An error occurred while updating the category:", error);
      throw new Error("An error occurred while updating the category."); 
    }
  };
  